import React from 'react';
import Icon from '@ant-design/icons';
import { useLocation } from 'react-router';
import { Empty } from 'antd';
import OwlLogo from '../../assets/logo.svg';
import { Locale } from '../../context/AppProvider';

import styles from './OwlVisionLandingContainer.module.scss';

export enum ErrorType {
  MissingTenantId = 'missing_tenant_id',
}

const OwlVisionContainer: React.FC = () => {
  const { state } = useLocation();
  const { messages } = React.useContext(Locale);

  const errorMessage = React.useMemo(() => {
    if (!state?.error) {
      return messages['platform.errors.default'];
    }

    return (
      messages[`platform.errors.${state?.error}`] ??
      messages['platform.errors.default']
    );
  }, [state?.error, messages]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Icon className={styles.owlLogo} component={OwlLogo} />
        <Empty image={null} description={errorMessage} />
      </div>
    </div>
  );
};

export default OwlVisionContainer;
